import { mediaItems } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-12">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-4">
            <i className="ri-vidicon-line"></i>
            独家影像
          </span>
          <h2 className="text-2xl md:text-3xl font-display text-foreground-950">独家采访与暗访实录</h2>
          <p className="mt-3 text-sm text-foreground-600">第一手影像资料，还原事件真相</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className={`group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-200/60 transition-all cursor-pointer ${
                i === 0 ? 'lg:col-span-2' : ''
              }`}
            >
              <div className={`relative overflow-hidden ${i === 0 ? 'aspect-[21/9]' : 'aspect-[16/10]'}`}>
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/30 flex items-center justify-center">
                  <div className="w-11 h-11 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50 group-hover:bg-primary-500 group-hover:scale-110 transition-all">
                    <i className="ri-play-fill text-lg md:text-xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-background-950/70 text-background-50 text-xs font-semibold backdrop-blur-sm">
                  {item.tag}
                </span>
                <span className="absolute bottom-3 right-3 px-2 py-1 rounded bg-background-950/70 text-background-50 text-xs backdrop-blur-sm">
                  {item.duration}
                </span>
              </div>
              <div className="p-5">
                <h3 className="text-base font-semibold text-foreground-900 leading-snug group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-3 text-xs text-foreground-500 flex items-center gap-1">
                  <i className="ri-eye-line"></i> {item.views} 次观看
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}